import { cachedAPIWrapper } from '../apiCaching/apiWrapper';
import { apiConfig } from '../config/apiConfig';
import { AxiosResponse } from 'axios';

export class StateHandler {
  static instance: any;

static getInstance(): StateHandler {
  StateHandler.instance ??= new StateHandler();
  return StateHandler.instance;
}

  public getStateFun(): void {
    this.initStateCall();
  }

  private initStateCall(): void {
    const baseUrl = apiConfig.stateApi;
    const conceptCode = (document.querySelector('#conceptCode') as HTMLInputElement)?.value || "MRE";
    const country = (document.querySelector('#countryCode') as HTMLInputElement)?.value || "us";
    const countryCode = country?.toUpperCase();
    const temp_zipcode = sessionStorage.getItem('temp_zipcode') ?? '';
    const caTest = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(temp_zipcode);

    if (conceptCode === 'FSP') {
      this.profileStateApi(baseUrl, countryCode);
    } else if (country === 'ca' && caTest) {
      this.profileStateApi(baseUrl, 'CA');
    } else {
      this.profileStateApi(baseUrl, 'US');
    }
  }


  private profileStateApi(baseUrl: string, countryCode: string | undefined): void {
    // Implementation for profile state API call for CA and US is same
    cachedAPIWrapper(baseUrl + countryCode)
      .then((response: AxiosResponse<any>) => {
        const data: any = response;
        const states: string[] = [];

        data?.forEach((element: any) => {
          states.push(`<option id="${element.stateCode}" value="${element.stateCode}">${element.stateName}</option>`);
        });

        const setState = document.querySelector('#modal-states.select-basic');
        const setStatedynamic = document.querySelector('#dynamic-modal-state.select-basic');
        const conceptCode = document.querySelector('#conceptCode') as HTMLSelectElement || "MRE";
        const updateStateDropdown = (dropdown: HTMLSelectElement | null) => {
          if (!dropdown) { return };
          dropdown.innerHTML = '';
          dropdown.innerHTML += `<option value="">${conceptCode?.value === 'PLG' ? 'Select State' : 'Select State/Province'}</option>`;
          dropdown.innerHTML += states.join('');
        };
        updateStateDropdown(setState as HTMLSelectElement);
        updateStateDropdown(setStatedynamic as HTMLSelectElement);
      })
      .catch((error: any) => {
        // Handle error
      });
  }

}
